var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1556 4.44444H0.844445C0.378071 4.44444 0 4.82252 0 5.28889V5.37778C0 5.84415 0.378071 6.22222 0.844445 6.22222H15.1556C15.6219 6.22222 16 5.84415 16 5.37778V5.28889C16 4.82252 15.6219 4.44444 15.1556 4.44444Z",
    fill: "#6B7085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1556 8.88889H0.844445C0.378071 8.88889 0 9.26696 0 9.73333V9.82222C0 10.2886 0.378071 10.6667 0.844445 10.6667H15.1556C15.6219 10.6667 16 10.2886 16 9.82222V9.73333C16 9.26696 15.6219 8.88889 15.1556 8.88889Z",
    fill: "#6B7085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1556 0H0.844445C0.378071 0 0 0.37807 0 0.844444V0.933334C0 1.39971 0.378071 1.77778 0.844445 1.77778H15.1556C15.6219 1.77778 16 1.39971 16 0.933334V0.844444C16 0.37807 15.6219 0 15.1556 0Z",
    fill: "#6B7085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/drag-icon.97b99b92ffd073d3098cb4849d8365ba.svg";
export { ForwardRef as ReactComponent };